import { CUSTOM_ELEMENTS_SCHEMA, NgModule, Pipe, PipeTransform } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OpenOrdersComponent } from './open-orders/open-orders.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatCardModule } from '@angular/material/card';

import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { EditOrdersComponent } from './edit-orders/edit-orders.component';
import { GridModule } from '../grid/grid.module';
import { AgGridModule } from 'ag-grid-angular';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule, MAT_DATE_LOCALE } from '@angular/material/core';
import { ToolbarModule } from '../toolbar/toolbar.module';
import { InputModule } from '@input/input.module';
import { NotificationModule } from '@notification/notification.module';
import { TeamsModule } from '../teams/teams.module';
import { CustomersModule } from '../customers/customers.module';
import { MatRadioModule } from '@angular/material/radio';
import { FileUploadDialogComponent } from './file-upload-dialog/file-upload-dialog.component';
import { FillDocumentComponent } from './edit/fill-document/fill-document.component';
import { DownloadDocumentComponent } from '@grid-cell/download-document.component';
import { FillAgbDialogComponent } from './edit/fill-agb-dialog/fill-agb-dialog.component';
import { OrderDialogService } from './order-dialog.service';
import { MatDialogModule } from '@angular/material/dialog';
import { FillReceiptDialogComponent } from './edit/fill-receipt-dialog/fill-receipt-dialog.component';
import { FillReportDialogComponent } from './edit/fill-report-dialog/fill-report-dialog.component';

import { PrintDocumentComponent } from '@grid-cell/print-document.component';
import { MergeDocumentsDialogComponent } from './merge-documents-dialog/merge-documents-dialog.component';
import { EditDocumentComponent } from './edit/edit-document/edit-document.component';
import { DeleteDocumentComponent } from '@grid-cell/delete-document.component';
import { MediaModule } from '../media/media.module';
import { ViewDocumentComponent } from '@grid-cell/view-document.component';
import { ViewDocumentDialogComponent } from './view/view-document-dialog/view-document-dialog.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { DocumentProgressBarComponent } from './document-progress-bar/document-progress-bar.component';
import { DeleteDialogComponent } from './delete/delete-dialog/delete-dialog.component';
import { DataModule } from '@data/data.module';
import { EmailDialogComponent } from './email/email-dialog/email-dialog.component';
import { EmailDialogButtonComponent } from '@grid-cell/email-dialog-button.component';
import { CloseOrderDialogComponent } from './close-order-dialog/close-order-dialog.component';
import { FillAcceptanceDialogComponent } from './edit/fill-acceptance-dialog/fill-acceptance-dialog.component';
import { DocumentPaginatorComponent } from './document-paginator/document-paginator.component';
import { ImageEditModule } from '../image-edit/image-edit.module';
import { CheckStateComponent } from './check-state/check-state.component';
import { PrintReceiptsDialogComponent } from './print-receipts-dialog/print-receipts-dialog.component';
import { MontageLocationComponent } from './montage-location/montage-location.component';
import {DragDropModule} from '@angular/cdk/drag-drop';
import { OrderDocumentsGridComponent } from './order-documents-grid/order-documents-grid.component';
import { DomSanitizer } from '@angular/platform-browser';
import { GridCellModule } from '@grid-cell/grid-cell.module';

@Pipe({ name: "safeHtml" })
export class SafeHtmlPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(value:any) {
    return this.sanitizer.bypassSecurityTrustHtml(value);
  }
}

@NgModule({
  declarations: [
    SafeHtmlPipe,
    CloseOrderDialogComponent,
    DeleteDialogComponent,
    EditDocumentComponent,
    EditOrdersComponent,

    FillAcceptanceDialogComponent,
    FillAgbDialogComponent,
    FillReceiptDialogComponent,
    FillReportDialogComponent,
    OpenOrdersComponent,
    CheckStateComponent,
    PrintReceiptsDialogComponent,
    MontageLocationComponent,
  ],
  imports: [
    CommonModule,
    AgGridModule,
    DragDropModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatCardModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatDialogModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatNativeDateModule,
    MatRadioModule,
    MatSelectModule,
    MatTabsModule,
    MatProgressBarModule,
    /* */
    CustomersModule,
    DataModule,
    GridModule,
    GridCellModule,
    ImageEditModule,
    InputModule,
    MediaModule,
    NotificationModule,
    TeamsModule,
    ToolbarModule,
    OrderDocumentsGridComponent,
    //
    EmailDialogButtonComponent,
    EmailDialogComponent,
    DeleteDocumentComponent,
    DocumentPaginatorComponent,
    DocumentProgressBarComponent,
    DownloadDocumentComponent,
    FileUploadDialogComponent,
    FillDocumentComponent,
    MergeDocumentsDialogComponent,
    PrintDocumentComponent,
    ViewDocumentComponent,
    ViewDocumentDialogComponent,
  ],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'de-DE' },
    OrderDialogService
  ],
  exports: [
    EditOrdersComponent,
    OpenOrdersComponent,
    PrintReceiptsDialogComponent
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
  ]
})
export class MontageOrdersModule { }
